import { render, staticRenderFns } from "./keyBoard.vue?vue&type=template&id=5af4f58a&"
import script from "./keyBoard.vue?vue&type=script&lang=js&"
export * from "./keyBoard.vue?vue&type=script&lang=js&"
import style0 from "./keyBoard.vue?vue&type=style&index=0&id=5af4f58a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports